export enum DocumentType {
	Portfolio = "Portfolio",
	PersonalBlog = "PersonalBlog",
	Resume = "Resume"
}
